module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/voucher",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _c('span', [_vm._v("Kode Voucher")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7c978e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/voucher/Navigation.vue
// module id = 1396
// module chunks = 0